import React, { useRef } from "react";
import { useSelector } from "react-redux";
import "./MineralsLegend.css";
import asbestosIcon from "../../data/icons/asbestos.webp";
import aluminumIcon from "../../data/icons/aluminum.webp";
import apatitesIcon from "../../data/icons/apatites.webp";
import chromeIcon from "../../data/icons/chrome.webp";
import cobaltIcon from "../../data/icons/cobalt.webp";
import copperIcon from "../../data/icons/copper.webp";
import diamondIcon from "../../data/icons/diamond.webp";
import goldIcon from "../../data/icons/gold.webp";
import ironIcon from "../../data/icons/iron.webp";
import magnesiteIcon from "../../data/icons/magnesite.webp";
import manganeseIcon from "../../data/icons/manganese.webp";
import molybdenumIcon from "../../data/icons/molybdenum.webp";
import nickelIcon from "../../data/icons/nickel.webp";
import otherIcon from "../../data/icons/other.png";
import platinumIcon from "../../data/icons/platinum.webp";
import polimetallIcon from "../../data/icons/polimetall.webp";
import silverIcon from "../../data/icons/silver.webp";
import sulfurIcon from "../../data/icons/sulfur.webp";
import tinIcon from "../../data/icons/tin.webp";
import talcumIcon from "../../data/icons/talcum.webp";
import titalIcon from "../../data/icons/tital.webp";
import tungstenIcon from "../../data/icons/tungsten.webp";
import uraniumIcon from "../../data/icons/uranium.webp";

const minerals = [
    { icon: aluminumIcon, name: "Алюминий" },
    { icon: apatitesIcon, name: "Апатиты" },
    { icon: asbestosIcon, name: "Асбест" },
    { icon: chromeIcon, name: "Хром" },
    { icon: cobaltIcon, name: "Кобальт" },
    { icon: copperIcon, name: "Медь" },
    { icon: diamondIcon, name: "Алмазы" },
    { icon: goldIcon, name: "Золото" },
    { icon: ironIcon, name: "Железо" },
    { icon: magnesiteIcon, name: "Магнезит" },
    { icon: manganeseIcon, name: "Марганец" },
    { icon: molybdenumIcon, name: "Молибден" },
    { icon: nickelIcon, name: "Никель" },
    { icon: platinumIcon, name: "Платина" },
    { icon: polimetallIcon, name: "Полиметаллы" },
    { icon: silverIcon, name: "Серебро" },
    { icon: sulfurIcon, name: "Сера" },
    { icon: tinIcon, name: "Олово" },
    { icon: talcumIcon, name: "Тальк" },
    { icon: titalIcon, name: "Титан" },
    { icon: tungstenIcon, name: "Вольфрам" },
    { icon: uraniumIcon, name: "Уран" },
    { icon: otherIcon, name: "Прочее" },
];

const MineralsLegend = () => {
    const scrollContainerRef = useRef(null);
    const selectedPoint = useSelector((state) => state.points.selectedPoint);

    const handleScroll = (direction) => {
        const container = scrollContainerRef.current;
        if (!container) return;

        const scrollAmount = 60;

        container.scrollBy({
            top: direction === "down" ? scrollAmount : -scrollAmount,
            behavior: "smooth",
        });
    };

    if (selectedPoint) {
        return null;
    }

    return (
        <div className="minerals-legend">
            <h3 className="legend-title">Условные обозначения</h3>
            <div className="legend-container">
                {/* <button 
                    className="scroll-button up"
                    onClick={() => handleScroll('up')}
                >
                    ‹
                </button> */}
                <div className="minerals-grid" ref={scrollContainerRef}>
                    {minerals.map((mineral, index) => (
                        <div key={index} className="mineral-item">
                            <img src={mineral.icon} alt={mineral.name} />
                            <span>{mineral.name}</span>
                        </div>
                    ))}
                </div>
                {/* <button 
                    className="scroll-button down"
                    onClick={() => handleScroll('down')}
                >
                    ‹
                </button> */}
            </div>
        </div>
    );
};

export default MineralsLegend;
